import { Assets } from './Assets'

export const InvestmentAssets = ({ assets, handleOnClick }) => {
  const investementAssets = (assets || []).filter(
    (option) => option.subType === InvestmentAssets.targetCategory
  )
  return (
    <Assets
      assets={investementAssets}
      handleOnClick={handleOnClick}
      category={InvestmentAssets.targetCategory}
    />
  )
}
InvestmentAssets.targetCategory = 'investment'
